module.exports = __webpack_public_path__ + "img/pic_8.cd34440b.jpg";